<ion-item
    *ngFor="let item of options"
    (click)="selectValue(item)"
    class="sc-ion-select-popover item ios in-list ion-focusable item-label hydrated"
    [ngClass]="{'item-radio-checked': item.value == selected}">
    <ion-label
        class="sc-ion-select-popover sc-ion-label-ios-h sc-ion-label-ios-s ios hydrated">
        {{item.title}}
    </ion-label>
    <ion-radio
        class="sc-ion-select-popover ios in-item interactive hydrated"
        role="radio"
        aria-checked="true"
        [ngClass]="{'radio-checked': item.value == selected}">
    </ion-radio>
</ion-item>
